module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.placeholderVisible) ? _c('div', {
    staticClass: "data-placeholder",
    style: ('height:' + _vm.height)
  }, [_vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder-content"
  }, [_c('i', {
    staticClass: "iconfont icon-route"
  }), _vm._v(" "), _c('div', [_vm._v("暂无数据")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f86d11b8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f86d11b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/dataPlaceholder.vue
// module id = 2991
// module chunks = 0